"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unzip;

var _max = _interopRequireDefault(require("./max.js"));

var _getLength = _interopRequireDefault(require("./_getLength.js"));

var _pluck = _interopRequireDefault(require("./pluck.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = array && (0, _max.default)(array, _getLength.default).length || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = (0, _pluck.default)(array, index);
  }

  return result;
}